<template>
  <div class="container">
    <div>
      <img
        srcset="../../../assets/image/ic_login@4x.png 4x"
        class="splash_login"
        @click="go2Login()"
      />
      <img
        srcset="../../../assets/image/ic_join@4x.png 4x"
        class="splash_join"
        @click="$router.push('signupInfo')"
      />
      <img
        srcset="../../../assets/image/ic_google@4x.png 4x"
        class="splash_google"
        @click="go2Google()"
      />
      <img
        srcset="../../../assets/image/ic_apple@4x.png 4x"
        class="splash_apple"
        @click="go2Apple()"
      />
      <img srcset="../../../assets/image/ic_splash.png" style="width:800px;"/>
    </div>
    <!--
    <div class="splash_copyright">
      <label class="splash_text">
        {{ $t("splash.brand")
        }}<span class="splash_label" style="margin-left: 5px">{{
          $t("splash.ceo_label")
        }}</span
        >{{ $t("splash.ceo_name") }}<br />
        <span class="splash_label">{{ $t("splash.corp_tel_label") }}</span
        >{{ $t("splash.corp_tel") }}<br />
        <span class="splash_label">{{ $t("splash.mail_order_business") }}</span
        >{{ $t("splash.mail_order_business_no") }}<br />
        <span class="splash_label">{{ $t("splash.corp_address_label") }}</span
        >{{ $t("splash.corp_address") }}<br />
        <span class="splash_label">{{ $t("splash.qna_center_label") }}</span
        ><a
          href="http://pf.kakao.com/_xgctis"
          target="_blank"
          style="color: #267fff"
          ><img
            srcset="../../../assets/image/ic_kakao@4x.png 6x"
            style="color: #267fff"
          />
          {{ $t("splash.qna_address") }}</a
        ><br />
        <span class="splash_label">{{ $t("splash.tel_label") }}</span
        >{{ $t("splash.tel") }}<br />
        <span
          class="splash_label2"
          @click="
            u.setState(self, {
              showTermPopup: true,
              title: $t('more.terms_of_use'),
              content: self.myinfo.setting.terms_of_service,
            })
          "
          >{{ $t("splash.provision1") }}</span
        ><span
          class="splash_label2"
          @click="
            u.setState(self, {
              showTermPopup: true,
              title: $t('more.privacy_policy'),
              content: self.myinfo.setting.privacy_policy,
            })
          "
          >{{ $t("splash.provision2") }}</span
        ><br />
        ⓒ 2022. {{ $t("splash.brand") }} Corp. All rights reserved.
      </label>
    </div>
    -->
    <TermPopup
      :visible.sync="showTermPopup"
      :title="title"
      :content="content"
    />
  </div>
</template>

<script>
import Utils from "../../../config/utils.js";
import TermPopup from "../../controls/popup/TermPopup";

const INTRO_TIME = 2000;
let startTime = new Date().getTime();

export default {
  name: "Splash",
  components: {
    TermPopup,
  },

  mounted() {
    this.getAppInfo();
    this.autoLogin();
  },

  data() {
    return {
      u: Utils,
      self: this,
      showTermPopup: false,
    };
  },

  methods: {
    autoLogin: function () {
      let phone = this.$perf.getString(this.$c.PREF_PARAMS.PHONE);
      let code = this.$perf.getString(this.$c.PREF_PARAMS.CODE);

      if (phone == "" || code == "") {
        // this.go2Login();
        return;
      }
      Utils.requestPost(this.$c.API.Auth.login, {
        phone_number: phone,
        code: code,
        device_id: this.$perf.uuid(),
        // fcm_token: this.$perf.fcm_token(),
        auto_login: "Y",
        isWeb: "Y",
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.accessToken = result.data.access_token;
          this.$perf.setString(
            this.$c.PREF_PARAMS.PHONE,
            phone.replaceAll("-", "")
          );
          this.$perf.setString(this.$c.PREF_PARAMS.CODE, code);
          this.getProfile();
        } else if (result.code == this.$c.API_RES_CODE.RESULT_CERT_ANSWER) {
          this.$router.push("/SignupQuiz");
        } else {
          // this.go2Login();
          Utils.toast(this, result.msg);
        }
      });
    },

    getProfile() {
      Utils.requestGet(this.$c.API.User.getProfile).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          this.myinfo.loadInfo();
          this.$router.push("/Home");
        } else {
          Utils.toast(this, result.msg);
          this.go2Login();
        }
      });
    },

    getAppInfo() {
      Utils.requestPost(this.$c.API.Auth.getAppInfo, {}).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.saveSetting(result.data);
          console.log(this.myinfo.setting);
          this.autoLogin();
        } else {
          // this.go2Login();
        }
      });
    },

    go2Login: function () {
      setTimeout(() => {
        this.$router.push("/Login");
      }, Math.max(0, INTRO_TIME - (new Date().getTime() - startTime)));
    },
    go2Main: function () {
      setTimeout(() => {
        this.$router.push("/Home");
      }, Math.max(0, INTRO_TIME - (new Date().getTime() - startTime)));
    },
    onHomeLink: function () {
      window.open("http://pf.kakao.com/_xgctis", "_blank");
    },
    go2Google: function () {
      window.open(
        "https://play.google.com/store/apps/details?id=co.kr.made",
        "_blank"
      );
    },
    go2Apple: function () {
      window.open("https://apps.apple.com/uz/app/id1601947522", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/auth/Splash.scss";

.container {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/auth/Splash.vue